import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getHexTextColorHex } from 'library/colors';
import { timelineContextConfig } from 'config/menu.config';
import { activityItemContent } from 'library/helpers';
import Menu from './Menu';

const TIME_FORMAT = 'HH:mm - [Day] DDD';
/**
 * @class renders an Activity
 * @extends Component
 */
const RosterBuilderItemRenderer = ({
  onContextClick, item, timeFormat, className, hiddenContextItems, showContextMenu
}) => {
  // formats
  const { activity, user } = item;

  const { name, activity_type } = activity;
  const data = {
    ...item,
    user,
    title: `${name} ${activity_type.code ? `(${activity_type.code})` : ''}` // If the roster is grouped by users we want to show activity details.
  };
  // set item background and foregorund colours
  const style = {
    background: data.color,
    color: className.indexOf('rct9k-items-selected') === -1
      ? getHexTextColorHex(data.color)
      : 'black'
  };
  // get the Success count for notifications
  const defaultNotifications = data.default_notifications && data.default_notifications.length
    ? <span className={classNames('rct9k-timebar-item__dot', 'black')} /> : null;
  const menuItems = showContextMenu ? timelineContextConfig([], hiddenContextItems) : [];
  return (
    <Menu
      data={item}
      menuItems={menuItems}
      onContextClick={onContextClick}
      title={data.title}
      content={activityItemContent(data, timeFormat)}
      className={className}
      style={style}
    >
      <span>
        {data.title}
        {defaultNotifications}
      </span>
    </Menu>
  );
};

RosterBuilderItemRenderer.propTypes = {
  className: PropTypes.string,
  item: PropTypes.object,
  timeFormat: PropTypes.string,
  showContextMenu: PropTypes.bool,
  hiddenContextItems: PropTypes.arrayOf(PropTypes.string),
  onContextClick: PropTypes.func
};

RosterBuilderItemRenderer.defaultProps = {
  className: '',
  item: {},
  showContextMenu: true,
  hiddenContextItems: [],
  onContextClick() {
  },
  timeFormat: TIME_FORMAT
};

export default RosterBuilderItemRenderer;
